import React from 'react';
import { Flex, Tooltip, Tag } from 'antd';
import Icon from '@mdi/react';
import { mdiAccountDetailsOutline, mdiHandshakeOutline, mdiAnchor } from '@mdi/js';

const CountIcons = ({ data }) => {
  const items = [
    { key: 'leads_count', icon: mdiAccountDetailsOutline, label: 'Leads' },
    { key: 'deals_count', icon: mdiHandshakeOutline, label: 'Deals' },
    { key: 'postbacks_count', icon: mdiAnchor, label: 'Postbacks' },
  ];

  if (!data) return null;

  return (
    <Flex gap='small' align='center'>
      {items.map((item) => {
        const count = data[item.key];

        if (!count) return null;
        return (
          <Tag className='rounded-md h-6 flex items-center justify-center m-0 border border-solid border-info-background'>
            <Tooltip
              destroyOnHidden
              className='cursor-pointer'
              key={item.key}
              title={`${item.label}: ${count}`}
            >
              <Icon className='text-info hover:text-blue' path={item.icon} size={0.8} />
            </Tooltip>
          </Tag>
        );
      })}
    </Flex>
  );
};

export default CountIcons;
